import * as React from 'react';
import Grid from "@mui/material/Grid";
import {useNavigate} from "react-router-dom";
import {useState} from "react";
import useRootHook from "../../hooks/useRoot";
import helpers from "../../helpers/common";
import AdminForm from "./AdminForm";
import admins from "../../models/admins";
import PageHeader from '../layout/PageHeader';
import SectionCard from '../layout/SectionCard';

export default function AdminAdd(props) {
    const {setShowLoader} = useRootHook()
    const navigate = useNavigate()
    const [errors, setErrors] = useState({});
    const [fields, setFields] = useState({super: false})

    const handleChange = (ev) => {
        const [, value, name] = helpers.getFormEventData(ev);

        setErrors({...errors, [name]: undefined});

        setFields((prevState) => {
            let newFields = {...prevState};
            newFields[name] = value;

            return newFields
        })
    }

    const handleBlur = (ev) => {
        const [, , name] = helpers.getFormEventData(ev)

        const newErrors = {...errors}
        const newFields = {...fields}

        typeof admins.fieldValidator[name] === 'function'
        && admins.fieldValidator[name](newFields, newErrors)
        setErrors(newErrors)
    }

    const handleSubmit = (ev) => {
        ev.preventDefault()
        const validationErrors = admins.methodValidator.add(fields)
        setErrors(validationErrors)

        if (Object.keys(validationErrors).length !== 0) return

        setShowLoader(true)
        admins.add(fields)
            .then(() => {
                setShowLoader(false)
                navigate('/admins')
            }).catch(() => setShowLoader(false))
    }

    return <React.Fragment>
        <Grid size={12}>
            <PageHeader title="Add admin" breadcrumbs={[['Dashboard', '/'], ['Admins', '/admins'], ['Add', '/admins/add']]} />
        </Grid>
        <Grid size={12}>
            <SectionCard sx={{ display: 'flex', flexDirection: 'column' }}>
                <AdminForm fields={fields} errors={errors} handleChange={handleChange}
                           handleBlur={handleBlur} handleSubmit={handleSubmit} />
            </SectionCard>
        </Grid>
    </React.Fragment>
}